export const CHART_CONST = {
  XAXIS_MAX: 7500,
  TEN_SEC_STRIP_CHART_CONTAINER: 'huinno-10sec-strip-detail-chart-container',
};
